/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Tab_SubscriptionInputs */

const en_settings_payments_tab_subscription = /** @type {(inputs: Settings_Payments_Tab_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

const zh_settings_payments_tab_subscription = /** @type {(inputs: Settings_Payments_Tab_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Settings_Payments_Tab_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_tab_subscription = /** @type {((inputs?: Settings_Payments_Tab_SubscriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Tab_SubscriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_tab_subscription(inputs)
	return zh_settings_payments_tab_subscription(inputs)
});
export { settings_payments_tab_subscription as "settings.payments.tab_subscription" }